/**
 * Environment access, in one place.
 *
 * Reading `import.meta.env` directly from components scatters configuration through the
 * app and makes it invisible to a reader. Everything the client needs is here.
 */
export const env = {
  /**
   * Where the browser is sent to begin sign-in.
   *
   * A full page navigation rather than a fetch, because it ends at GitLab's own login form.
   */
  signInUrl: '/api/v1/auth/gitlab/start',

  /** The public address, used in the footer. */
  publicHost: 'Task.ParsianDevelope.ir',
} as const;
